var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbsolutewave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 206.529,
    height: 27.911,
    viewBox: "0 0 206.529 27.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 206.529,
    height: 27.911,
    transform: "translate(0 0)",
    fill: "#97c7eb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(-1612.148 -162.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(1612.148 162.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43739",
    "data-name": "Path 43739",
    d: "M206.528,17.1c.037.743-5.575,8.366-6.17,8.431-1,.11-1.515-.752-2.177-1.237-3.93-2.878-7.9-5.717-11.677-8.782-2.059-1.668-3.538-1.891-5.754-.072-4.822,3.961-9.987,7.5-14.893,11.364-1.762,1.388-2.994,1.528-4.845.054-5.079-4.044-10.395-7.789-15.51-11.791-1.662-1.3-2.8-1.38-4.519-.017-5.087,4.035-10.4,7.781-15.5,11.806-1.816,1.434-3.069,1.38-4.857-.041-4.79-3.807-9.839-7.29-14.587-11.146-2.213-1.8-3.773-2.011-6.09-.114-4.731,3.875-9.808,7.325-14.585,11.146-1.9,1.517-3.209,1.605-5.149.059C75.236,22.8,70,19.144,65.017,15.183c-1.818-1.443-3.053-1.409-4.849.01-5,3.949-10.233,7.6-15.2,11.579C43,28.351,41.651,28.159,39.8,26.7c-4.8-3.792-9.869-7.259-14.575-11.163-2.336-1.938-3.913-1.623-6.061.121-3.778,3.069-7.8,5.832-11.648,8.82-1.435,1.116-2.226,1.281-3.547-.384-5.5-6.933-5.574-6.87,1.575-12.234,4.7-3.523,9.482-6.937,14.042-10.629,2.076-1.681,3.483-1.516,5.477.089,4.668,3.759,9.617,7.167,14.281,10.931,2.174,1.754,3.722,2.044,6.052.113,4.71-3.9,9.785-7.354,14.578-11.157,1.869-1.483,3.2-1.638,5.161-.067C70.1,5.121,75.328,8.785,80.324,12.733c1.8,1.42,3.063,1.427,4.87,0,4.994-3.952,10.23-7.6,15.2-11.585,1.962-1.574,3.28-1.423,5.15.061,4.694,3.728,9.717,7.055,14.277,10.933,2.6,2.211,4.307,1.751,6.673-.156,4.666-3.761,9.617-7.166,14.311-10.893,1.789-1.42,3.038-1.473,4.854-.037,5.094,4.027,10.41,7.774,15.5,11.811,1.721,1.366,2.856,1.27,4.512-.031C170.671,8.9,175.857,5.19,180.87,1.261c1.811-1.42,3.12-1.773,5.154-.166,6.075,4.8,12.36,9.331,18.546,13.989.772.581,1.773.991,1.958,2.021",
    fill: "#97c7eb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsolutewave);
export default __webpack_public_path__ + "static/media/absolutewave.d7675bf059523f54d549c51eab954078.svg";
export { ForwardRef as ReactComponent };